/**
 * Typology-style line under the homepage hero.
 * Copy is Leaves (24V, patented track, outdoor), not the skincare original.
 */
(function () {
  'use strict';

  if (!document.documentElement || document.documentElement.dataset.leavesTypoBand === '1') return;
  document.documentElement.dataset.leavesTypoBand = '1';

  function findHero() {
    return (
      document.querySelector('#leaves-home [data-section-id="leaves-74fc"]') ||
      (document.querySelector('#leaves-home [data-leaves-type="Slideshow"]') &&
        document
          .querySelector('#leaves-home [data-leaves-type="Slideshow"]')
          .closest('[data-leaves-type="FlexSection"]'))
    );
  }

  /* European copy of: 全球通用 · DC 24V · 专为户外而生 · 83项专利 · 全原创设计 · 自有模具
     Duplicates replace older "24V safe" / "Made for outdoors" / "83+ Patents" — not added twice. */
  var ITEMS = [
    { text: 'Worldwide DC 24V' },
    { text: 'Born for outdoors' },
    { text: '83+ Patents', patent: true },
    { text: 'Original design' },
    { text: 'In-house molds' },
  ];

  function logoSrc() {
    if (window.LEAVES_TYPO_LOGO) return String(window.LEAVES_TYPO_LOGO);
    var header = document.querySelector('.header-logo__image');
    return header ? header.getAttribute('src') || '' : '';
  }

  function group(hidden) {
    var html = '<div class="leaves-typo-band__group"' + (hidden ? ' aria-hidden="true"' : '') + '>';
    var src = logoSrc().replace(/"/g, '');
    if (src) {
      html += '<img class="leaves-typo-band__logo" src="' + src + '" alt="' + (hidden ? '' : 'Leaves') + '">';
    }
    var patent = window.LEAVES_PATENT_LOGO ? String(window.LEAVES_PATENT_LOGO).replace(/"/g, '') : '';
    ITEMS.forEach(function (item) {
      if (item.patent && patent) {
        html += '<span class="leaves-typo-band__patent">';
        html +=
          '<img class="leaves-typo-band__patent-mark" src="' +
          patent +
          '" alt="' +
          (hidden ? '' : item.text) +
          '">';
        html += '<span>' + item.text + '</span>';
        html += '</span>';
      } else {
        html += '<span>' + item.text + '</span>';
      }
    });
    html += '</div>';
    return html;
  }

  function markup() {
    var html = '<div class="leaves-typo-band__ticker">';
    for (var i = 0; i < 6; i += 1) html += group(i > 0);
    html += '</div>';
    return html;
  }

  function mount() {
    var hero = findHero();
    if (!hero || !hero.parentNode) return false;
    var band = document.querySelector('.leaves-typo-band');
    if (!band) {
      band = document.createElement('div');
      band.className = 'leaves-typo-band';
      band.setAttribute('data-leaves-typo-band', '');
      band.setAttribute('role', 'region');
      band.setAttribute(
        'aria-label',
        'Leaves. Worldwide DC 24V. Born for outdoors. 83+ patents. Original design. In-house molds'
      );
      band.innerHTML = markup();
    }
    if (band.previousElementSibling !== hero) {
      hero.parentNode.insertBefore(band, hero.nextSibling);
    }
    return band.previousElementSibling === hero;
  }

  function boot() {
    mount();
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (mount() && tries > 4) window.clearInterval(timer);
      if (tries > 40) window.clearInterval(timer);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
